export enum adminCompanyNewTypes {
    FETCH_ADMIN_COMPANY_NEW_REQUEST = "FETCH_ADMIN_COMPANY_NEW_REQUEST",
    FETCH_ADMIN_COMPANY_NEW_SUCCESS = "FETCH_ADMIN_COMPANY_NEW_SUCCESS",
    FETCH_ADMIN_COMPANY_NEW_FAILURE = "FETCH_ADMIN_COMPANY_NEW_FAILURE",
  }